module.exports = __webpack_public_path__ + "img/nodata.bc9ebc0a.png";